module.exports = __webpack_public_path__ + "static/media/portrait-fallback.54e9a01d.png";